import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTrigger,
} from "@/components/ui/dialog";

export const ImageDisplay = ({ children, url }: { children: React.ReactNode, url: string }) => {
    return (
        <Dialog>
            <DialogTrigger asChild>{children}</DialogTrigger>
            <DialogContent
                className=" text-white border-0  break-words text-wrap"    
            >
                <DialogHeader className="text-center w-full items-start text-wrap mt-4">
                    <div className="flex flex-col space-y-2 py-2 text-wrap">
                        <div className="flex flex-col gap-2 text-wrap w-full items-center">
                            <img src={url} className="w-auto" />
                        </div>
                    </div>
                    <div className="items-center text-wrap">
                        <a
                            href={url}
                            target="_blank"
                            className="text-blue-400 hover:cursor-pointer"
                        >
                            View Original Image
                        </a>
                    </div>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    );
}
